<div class='clan_list'>
  <app-skeleton-universal [count]='5' [cheight]='35' [rwidth]='100' *ngIf='loading'></app-skeleton-universal>
  <div  *ngIf='publishers'>
    <div *ngFor='let publisher of publishers; let i  = index' class='clans' (click)="navigate(publisher)">
      <span class="app-custom-checkbox-text color-white ml-1-0" (click)='navigate(publisher.publisherId)' style='cursor: pointer'>
        <div class='clan_item '>
          <app-image-wrapper [avatar]='publisher.publisherId' [class]="'medium radius'"></app-image-wrapper>
          <span>{{publisher.publisherId?.name}}</span>
        </div>
      </span>
    </div>
  </div>
</div>
